import React from "react";
import { Chart } from "react-google-charts";

export const data = [
     [
       { type: "number", label: "x" },
       { type: "number", label: "values" },
       { id: "i0", type: "number", role: "interval" },
       { id: "i1", type: "number", role: "interval" },
       { id: "i2", type: "number", role: "interval" },
       { id: "i2", type: "number", role: "interval" },
       { id: "i2", type: "number", role: "interval" },
       { id: "i2", type: "number", role: "interval" },
     ],
     [1, 100, 100, null, null, null, null, null],
     [2, 120, null, 120, null, null, null, null],
     [3, 130, null, null, 130, null, null, null],
     [4, 90, null, null, null, 90, null, null],
     [5, 70, null, null, null, null, 70, null],
     [6, 30, null, null, null, null, null, 30],
     [7, 80, null, null, null, null, null, null],
     [8, 100, null, null, null, null, null, null],
   ];

export const options = {
  series: [{ color: "#1A8763" }],
  intervals: { barWidth: 0, style: "point" }, // Set barWidth to 0 to display dots
  legend: "none",
  curveType: "function", // Use a function curve (lines)
};

export default function App() {
  return (
    <Chart
      chartType="LineChart"
      width="100%"
      height="400px"
      data={data}
      options={options}
    />
  );
}
//sd